// export const debug = (state) => state.debug;

export const extconf = (state) => state.extconf;
export const apiUrl = (state) => state.extconf.apiUrl;
// export const counter = (state) => state.counter;
// export const csrfToken = (state) => state.extconf.csrfToken;
export const backendBaseUrl = (state) => state.extconf.backendBaseUrl;
// export const lang = (state) => state.extconf.lang;

export const currentVariantId = (state) => state.currentVariantId;
export const activeImageIndex = (state) => state.activeImageIndex;

export const variants = (state) => state.variants;
export const images = (state) => state.images;
